import type { SkinId } from './types';
import type { SkinComponentType } from '@/shared/stores/useSkinStore';

export type { SkinComponentType };

export interface SkinMetadata {
  id: SkinId;
  nameKey: string;
  available: boolean;
}

export const SKIN_METADATA: SkinMetadata[] = [
  { id: 'basics', nameKey: 'skins.basics', available: true },
  { id: 'celeste', nameKey: 'skins.celeste', available: true },
  { id: 'crypt', nameKey: 'skins.crypt', available: true },
  { id: 'magma', nameKey: 'skins.magma', available: true },
  { id: 'pc', nameKey: 'skins.pc', available: true }
];

export const SKIN_SECTIONS: readonly { type: SkinComponentType; labelKey: string }[] = [
  { type: 'pawn', labelKey: 'skins.sections.pawns' },
  { type: 'dice', labelKey: 'skins.sections.dice' },
  { type: 'base', labelKey: 'skins.sections.bases' },
  { type: 'plateaux', labelKey: 'skins.sections.plateaux' }
];
